import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "my-0 mx-3"
};
const _hoisted_3 = {
  class: "my-0 mx-3"
};
const _hoisted_4 = {
  class: "my-0 mx-3"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SubscriptionTypeInfo = _resolveComponent("SubscriptionTypeInfo");
  const _component_b_icon = _resolveComponent("b-icon");
  const _component_b_col = _resolveComponent("b-col");
  const _component_b_row = _resolveComponent("b-row");
  return $props.subscription ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_SubscriptionTypeInfo, {
    subscriptiontype: $props.subscription.subscriptiontype,
    onRefresh: _cache[0] || (_cache[0] = $event => _ctx.$emit('refresh'))
  }, {
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")], undefined, true),
    _: 3
  }, 8, ["subscriptiontype"]), _createVNode(_component_b_row, null, {
    default: _withCtx(() => [_createVNode(_component_b_col, null, {
      default: _withCtx(() => [_withDirectives(_createElementVNode("h4", _hoisted_2, [_createVNode(_component_b_icon, {
        icon: "calendar"
      }), _createTextVNode(" Next Bill Date: " + _toDisplayString($props.subscription.enddate), 1)], 512), [[_vShow, !($props.subscription.balance > 0 || $props.subscription.nextsubscriptiontype_id > 0 || $props.subscription.autorenew == 0)]])], undefined, true),
      _: 1
    })], undefined, true),
    _: 1
  }), _withDirectives(_createVNode(_component_b_row, {
    class: "text-danger"
  }, {
    default: _withCtx(() => [_createVNode(_component_b_col, null, {
      default: _withCtx(() => [_createElementVNode("h4", _hoisted_3, [_createVNode(_component_b_icon, {
        icon: "x-circle-fill"
      }), _cache[1] || (_cache[1] = _createTextVNode(" Subscription Cancelled ", -1))]), _createElementVNode("p", _hoisted_4, " Subscription will remain active until " + _toDisplayString($props.subscription.enddate), 1)], undefined, true),
      _: 1
    })], undefined, true),
    _: 1
  }, 512), [[_vShow, $props.subscription.autorenew == 0 && $props.subscription.cancel == 1]])])) : _createCommentVNode("", true);
}